import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, DeferLoadingStrategy } from '@spartacus/core';
import { GenericLinkModule } from '@spartacus/storefront';
import { LinkComponent } from './link.component';

@NgModule({
  declarations: [LinkComponent],
  imports: [
    CommonModule,
    GenericLinkModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSLinkComponent: {
          component: LinkComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
  providers: [{ provide: LinkComponent }],
})
export class ShimanoLinkModule {}
